import React from 'react'
import './contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri' 
import { BsWhatsapp } from 'react-icons/bs'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'

const Contact = (props) => {
  const form = useRef();

  // const onClick = (e) => {
  //   e.preventDefault();
  //   props.handleChange();
  // }

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_4pq2dd9', 'template_iqriy8q', form.current, {
        publicKey: 'XUZo45SMXHq4qKHro',
      })
      .then(
        () => {
          console.log('SUCCESS! Email sent successfully');
          props.handleChange();
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );

    
    e.target.reset();
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>harpreetsi9h@gmail.com</h5>
            <a href="mailto:harpreetsi9h@gmail.com">Send a message</a>
          </article>
          <article className="contact__option">
            <RiMessengerLine className='contact__option-icon'/>
            <h4>Messenger</h4>
            <h5>Harpreet Singh</h5>
            <a href="https://m.me/harpreetsi9h">Send a message</a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>+19052263345</h5>
            <a href="https://api.whatsapp.com/send?phone=+19052263345">Send a message</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact